import './Checkout.css';
import React, { useEffect } from 'react';
import { Checkbox, FormControlLabel, Grid, Typography } from '@material-ui/core';
import { GenerateFields } from '../../components/checkout/CheckoutInput';
import { ICheckoutState } from '../../store/CheckoutContext';

interface Props {
  state: ICheckoutState;
  setState: React.Dispatch<React.SetStateAction<{ [key: string]: any }>>;
}

const StepFirst: React.FC<Props> = props => {
  const { state, setState } = props;

  return (
    <div className="CheckoutIframe">
      <Grid item>
        <div className="">
          <Typography variant="h6" gutterBottom>
            Payment method
          </Typography>
          <GenerateFields state={state} setState={setState} fieldName={'paymentMethod'} />
          <Grid item xs={12}>
            <FormControlLabel
              control={<Checkbox color="secondary" name="saveCard" value="yes" />}
              label="Remember credit card details for next time"
            />
          </Grid>
        </div>
      </Grid>
    </div>
  );
};

export default StepFirst;
